<template>
  <div class="grid-container full">
    <div class="grid-x programemsCarousel page-contents-8">
      <div class=" small-12 cell">
        <div class="grid-x">
          <div class="small-12 cell">
            <h2>We build award-winning development programmes</h2>
          </div>
        </div>


        <div class="grid-x">
          <div class="small-1 medium-2 cell align-center align-middle" style="display: flex; " @click="previous">
            <img tabindex="19" class="prevArrow" src="@/assets/img/icons/left-carousel-arrow.png" @keypress="previous" />
          </div>
          <div class="small-10 medium-8 cell">

            <div class='carousel-view'>
              <transition-group
                name='carousel'
                class='carousel'
                tag="div">
                <div
                  v-for="(slide, index) in slides"
                  class='slide'
                  :key="index">
                  <span class="carouselLabel">
                    <a :tabindex="slide.tabindex" v-if="slide.link !== ''" v-bind:href="slide.link" target="_blank" rel="noopener">{{ slide.label }}</a>
                    <span v-else style="border: 0;">{{ slide.label }}</span>
                  </span>
                </div>
              </transition-group>
            </div>
          </div>
          <div class="small-1 medium-2 cell align-center align-middle" style="display: flex; " @click="next">
            <img tabindex="21" class="nextArrow" src="@/assets/img/icons/right-carousel-arrow.png" @keypress="next" />
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'RareProgrammesCarousel',
  components: {
  },
  data() {
    return {
      w: window.width,
      largeText: null,
      smallText: null,
      slides: [
        {
          label: 'Articles',
          link: 'https://www.rarerecruitment.co.uk/articles/',
          largeText: 'Rare’s multi-award-winning programme for brilliant ethnic minority candidates interested in applying for vacation schemes and training contracts with our legal clients. Candidates are approximately 27 times more likely to get hired after completing Articles.',
          smallText: 'For brilliant ethnic minority candidates interested in applying for vacation schemes and training contracts with our clients.',
          id: 0,
          tabindex: -1,
        },
        {
          label: 'Advocate',
          link: 'https://www.rarerecruitment.co.uk/advocate',
          largeText: 'Rare’s new and exclusive development programme for British students from under-represented ethnic minority backgrounds who are interested in commercial law. The programme is sponsored by three top City law firms and run by Rare.',
          smallText: 'Rare’s new and exclusive development programme for British students from under-represented ethnic minority backgrounds who are interested in commercial law.',
          id: 1,
          tabindex: -1,
        },
        {
          label: 'Articles',
          link: 'https://www.rarerecruitment.co.uk/articles/',
          largeText: 'Rare’s multi-award-winning programme for brilliant ethnic minority candidates interested in applying for vacation schemes and training contracts with our legal clients. Candidates are approximately 27 times more likely to get hired after completing Articles.',
          smallText: 'For brilliant ethnic minority candidates interested in applying for vacation schemes and training contracts with our clients.',
          id: 2,
          tabindex: -1,
        },
        {
          label: 'Advocate',
          link: 'https://www.rarerecruitment.co.uk/advocate',
          largeText: 'Rare’s new and exclusive development programme for British students from under-represented ethnic minority backgrounds who are interested in commercial law. The programme is sponsored by three top City law firms and run by Rare.',
          smallText: 'Rare’s new and exclusive development programme for British students from under-represented ethnic minority backgrounds who are interested in commercial law.',
          id: 3,
          tabindex: -1,
        },
      ],
    };
  },

  methods: {
    next() {
      // this.largeText = this.slides[2].largeText;
      // this.smallText = this.slides[2].smallText;

      const first = this.slides.shift();
      this.slides = this.slides.concat(first);

      // Add a tabindex of 20 to the 3rd tab and add -1 to the 2nd tab.
      // This makes it so only the current highlighted tab is keyboard accessible between the two arrows.
      this.slides[0].tabindex = -1;
      this.slides[1].tabindex = 20;
    },
    previous() {
      // this.largeText = this.slides[1].largeText;
      // this.smallText = this.slides[1].smallText;

      const last = this.slides.pop();
      this.slides = [last].concat(this.slides);

      // See comment on line 117.
      this.slides[0].tabindex = 20;
      this.slides[1].tabindex = -1;
    },
  },
  mounted() {
    // this.largeText = this.slides[2].largeText;
    // this.smallText = this.slides[2].smallText;
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  h2
  {
    color: #ffffff;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: center;
  }

  p {
    color: #ffffff;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
  }

  a {
    color: #ffffff;
    text-decoration: none;
  }

  @media only screen and (max-width: 640px)  {
    .programemsCarousel {
      min-height: 412px;
      background-image: url("../../assets/img/backgrounds/programmes-carousel.jpg");
      background-position: center;
    }

    h2 {
      font-size: 28px;
      line-height: 1.43;
      margin: 40px 0 16px 0;
    }

    p {
      font-size: 14px;
      line-height: 1.71;
    }

    .carouselLabel {
      font-size: 28px;
    }

    .slide {
      flex: 0 0 20em;
    }

    .carousel {
      padding-left: 0;
      margin-left: 260px;
    }
  }

  @media only screen and (min-width: 641px)  {
    .programemsCarousel {
      min-height: 584px;
      background-image: url("../../assets/img/backgrounds/programmes-carousel.jpg");
    }

    h2 {
      font-size: 56px;
      line-height: 1.29;
      margin: 90px 0 12px 0;
    }

    p {
      font-size: 21px;
      line-height: 1.52;
    }

    .carouselLabel {
      font-size: 40px;
    }

    .carousel {
      padding-left: 0;
      margin-left: 429px;
    }

    .slide {
      flex: 0 0 30em;
    }

  }

  .carousel-view {
    // border: 2px solid blue;
    height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    margin-bottom: 30px;
  }

  .carousel {
    // border: 2px solid green;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 250%;
    min-height: 150px;
    overflow: hidden;
    //margin-left: -850px;
  }

  .slide {
    //border: 2px solid red;
    transform: translateZ(0) scale(1.0, 1.0);
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    transition: transform 0.3s ease-in-out;
    opacity: 0.5;
    overflow: hidden;
  }

  .slide:nth-of-type(2) {
    opacity: 1 !important;
  }

  .slide:nth-of-type(2) span {
    //color: red;
    opacity: 1 !important;
    border-bottom: 5px solid $green-highlight;
  }

  .carouselLabel {
    color: #ffffff;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: 6px;
    text-align: center;
    padding: 14px 0;
  }

  .carousel-controls {
    width: 100%;
    padding: 0;
    margin: 0;
    z-index: 99;
    position: relative;
    display: block;
  }

  .prevArrow {
    cursor: pointer;
    display: inline-flex;
    width: 24px;
    height: 24px;
  }

  .nextArrow {
    cursor: pointer;
    display: inline-flex;
    width: 24px;
    height: 24px;
  }

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {

    .carousel {
      text-align: center;
    }
    .slide {
      display: none;
      overflow: visible;
      width: 100%;
      transition: none;
    }

    .slide:nth-of-type(3) {
      display: block !important;
      opacity: 1 !important;
      text-align: center;
      margin: 50px 0 0 25%;
    }

    .slide:nth-of-type(3) span {
      opacity: 1 !important;
      border-bottom: 5px solid $green-highlight;
      text-align: center;
      margin-right: 170px;
    }

  }


</style>



// WEBPACK FOOTER //
// src/components/carousels/programmesCarousel.vue